export const revealOrganization = (data: any) => {
  return (
    data?.map((o: any) => {
      return o.organization;
    }) || []
  );
};
